import { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// Types
import RefineStopReasons from 'app/types/RefineStopReasons';
// Models
import { IMessage } from 'app/models/ChatAI';
// Mui
import { Box, Theme } from '@mui/material';

interface IProps {
  message: IMessage | undefined;
  lastMessage: IMessage | undefined;
  isRefineActionAllowed: boolean;
  analyzedPagesPercent: number;
}

export default function RefineMessageRelevantText({
  message,
  lastMessage,
  isRefineActionAllowed,
  analyzedPagesPercent
}: IProps) {
  const { t } = useTranslation();

  const showExtendedText = useMemo(() => {
    if (!isRefineActionAllowed) return false;
    // If last message is not defined or has no metadata, do not show extended text
    if ( lastMessage?.metadata?.refineStopReason === RefineStopReasons.MaxTokens || analyzedPagesPercent === 100 ) return false;
    // Show extended text if lastMessage is same as current selected message
    return message?.id === lastMessage?.id;
  }, [lastMessage, message, isRefineActionAllowed, analyzedPagesPercent]);

  const roundedAnalyzedPercents = Math.round(analyzedPagesPercent);

  return (
    <Box
      sx={(theme:Theme) => ({
        bgcolor: theme.palette.primary.light,
        fontSize: 11,
        px: 4,
        py: 2
      })}
    >{roundedAnalyzedPercents === 100 ? (
        t('pages.aiChat.refineRelevantFullCoverageText')
      ) : (
        <Fragment>
          {t('pages.aiChat.refineRelevantText', { percents: roundedAnalyzedPercents })}
          {showExtendedText
            ? ` ${t('pages.aiChat.refineRelevantExtendedText')}`
            : ''
          }
        </Fragment>
      )}
    </Box>
  )
}
